import LogoMonogram from '../../src/legacy/LogoMonogram';
export default LogoMonogram;
